import React, { Component } from 'react'
import { router } from 'router'

import styles from './styles.scss'

import { TimelineMax, TweenMax, Power3 } from 'gsap'
import SplitText from 'utils/gsapPlugins/SplitText.min'

import raf from 'src/utils/raf'
import resize from 'src/utils/resize'
import values from 'src/values'
import config from 'src/config'
import { getHeight, getTop } from 'src/helpers'
import Scroller from 'src/utils/scroller'

export default class WorldItem extends Component {
  constructor(props) {
    super(props)
    this.key = `worldItem${Math.random()}`
  }

  componentDidMount() {
    this.initTL()
    this.onResize()
    Scroller.updateScrollHeight()

    raf.add(this.onRAF)
    resize.add(this.onResize, this.key)
  }

  componentWillUnMount() {
    raf.remove(this.raf)
    resize.remove(this.onResize, this.key)
  }

  initTL() {
    this.tlRAF = new TimelineMax({
      paused: true
    })

    this.tlRAF.fromTo(
      this.refs.imgContainer,
      1,
      {
        y: 80
      },
      {
        y: 0
      },
      0
    )

    this.tlAnimateIn = new TimelineMax({
      paused: true,
      onStart: () => {
        this.tlAnimateInIsPlaying = true
      },
      onComplete: () => {
        this.tlAnimateInIsEnded = true
        this.tlAnimateInIsPlaying = false
      }
    })

    const splitTitle = new SplitText(this.refs.title, {
      type: 'lines',
      linesClass: 'overflow-txt'
    })

    splitTitle.lines.map((line, i) => {
      this.tlAnimateIn.fromTo(
        line,
        1.5,
        {
          y: 25,
          opacity: 0
        },
        { y: 0, opacity: 1, ease: Power3.easeOut },
        i * 0.25
      )
    })

    this.tlAnimateIn.fromTo(
      this.refs.content,
      1.7,
      {
        opacity: 0,
        y: 25
      },
      { opacity: 1, y: 0, ease: Power3.easeOut },
      0.5
    )

    this.tlAnimateIn
      .fromTo(
        this.refs.btn,
        1,
        {
          opacity: 0
        },
        { opacity: 1, ease: Power3.easeOut },
        0.3
      )
      .fromTo(
        this.refs.tLine,
        1,
        {
          x: '-100%'
        },
        { x: '0%', ease: Power3.easeOut },
        0.3
      )
      .fromTo(
        this.refs.bLine,
        1,
        {
          x: '100%'
        },
        { x: '0%', ease: Power3.easeOut },
        0.3
      )

    this.tlAnimateDiscover = new TimelineMax({
      paused: true,
      onStart: () => {
        this.tlAnimateDiscoverIsPlaying = true
      },
      onComplete: () => {
        this.tlAnimateDiscoverIsPlaying = false
      }
    })

    this.tlAnimateDiscover
      .to(
        this.refs.tLine,
        0.6,
        {
          x: '-100%',
          ease: Power3.easeOut
        },
        0
      )
      .fromTo(
        this.refs.tLine,
        0.6,
        {
          x: '100%'
        },
        { x: '0%', ease: Power3.easeOut },
        0.6
      )
      .to(
        this.refs.bLine,
        0.6,
        {
          x: '100%',
          ease: Power3.easeOut
        },
        0
      )
      .fromTo(
        this.refs.bLine,
        0.6,
        {
          x: '-100%'
        },
        { x: '0%', ease: Power3.easeOut },
        0.6
      )
  }

  resetTL() {
    this.tlAnimateInIsPlaying = false
    this.tlAnimateInIsEnded = false
    this.tlAnimateIn.pause()
    this.tlAnimateIn.progress(0)
  }

  onResize = () => {
    if (!this.refs.component) return

    const $component = this.refs.component.getBoundingClientRect()
    const starter =
      600 + this.props.item * 300 > 0 ? 600 + this.props.item * 300 : 0
    this.topComponent = this.props.pos
      ? $component.top + values.scroll.currentY - starter
      : $component.top + values.scroll.currentY

    this.leftComponent = $component.left

    const $gradient = this.refs.gradient.getBoundingClientRect()
    this.topGradient = $gradient.top + values.scroll.currentY
    this.leftGradient = $gradient.left

    this.hComponent = this.refs.component.offsetHeight
    this.wComponent = this.refs.component.offsetWidth

    TweenMax.set(this.refs.component, { height: this.wComponent })

    this.wImgContainer = this.refs.imgContainer.offsetWidth

    const wMargeMobile = values.viewport.width * 16.677 / 100

    TweenMax.set(this.refs.imgContainer, {
      height:
        values.viewport.width < config.bp.md
          ? this.wComponent
          : this.wComponent - 50,
      width:
        values.viewport.width < config.bp.md
          ? this.wComponent
          : this.wComponent - 50
    })

    TweenMax.set(this.refs.gradientImgContainer, {
      x: values.viewport.width < config.bp.md ? wMargeMobile / 2 : 0
    })

    if (values.viewport.width < config.bp.md && !this.tlAnimateIn.progress()) {
      this.tlAnimateIn.progress(100)
      this.tlRAF.progress(50)
    }
  }

  onRAF = () => {
    if (!this.refs.component || values.viewport.width < config.bp.md) return

    this.perc =
      (values.scroll.currentY + values.viewport.height - this.topComponent) /
      (values.viewport.height + this.hComponent)

    this.tlRAF && this.perc >= 0 && this.tlRAF.progress(this.perc)

    const perc = 0.1

    this.perc >= perc &&
      !this.tlAnimateInIsEnded &&
      !this.tlAnimateInIsPlaying &&
      this.tlAnimateIn.play(0)

    this.perc <= -0.5 && this.resetTL()
  }

  onMouseEnter = () => {
    if (
      !this.tlAnimateInIsEnded ||
      this.tlAnimateInIsPlaying ||
      values.viewport.width < config.bp.md
    )
      return

    TweenMax.to(this.refs.imgContainer, 0.6, {
      z: 20,
      ease: Power3.easeOut
    })

    this.tlAnimateDiscover.play(0)
  }

  onMouseLeave = () => {
    if (
      !this.tlAnimateInIsEnded ||
      this.tlAnimateInIsPlaying ||
      values.viewport.width < config.bp.md
    )
      return

    TweenMax.to(this.refs.imgContainer, 2, {
      z: 1,
      ease: Power3.easeOut
    })
  }

  onMouseEnterDiscover = () => {
    !this.tlAnimateDiscoverIsPlaying && this.tlAnimateDiscover.play(0)
  }

  onClickDiscover = () => {
    const ctx = router.getContext()

    router.goto(router.getRoute('world', { param: this.props.url }, ctx.locale))
  }

  render() {
    return (
      <div
        ref="component"
        onMouseLeave={this.onMouseLeave}
        onMouseEnter={this.onMouseEnter}
        onMouseMove={this.mouseMove}
        onClick={this.onClickDiscover}
        className="component world-item">
        <h3 ref="title">{this.props.title}</h3>
        <p
          ref="content"
          className="content"
          dangerouslySetInnerHTML={{ __html: this.props.content }}
        />
        <div className="world-item-container">
          <div ref="imgContainer" className="img-container">
            <div ref="gradientImgContainer" className="gradient-img-container">
              <img
                ref="img"
                src={`${process.env.PUBLIC_URL}/img/${this.props.img}`}
              />
              <span ref="gradient" className="gradient" />
            </div>
          </div>
        </div>
        <div
          onMouseEnter={this.onMouseEnterDiscover}
          onMouseLeave={this.onMouseLeaveDiscover}
          className="btn-container">
          <span ref="tLine" className="line t-line" />
          <p ref="btn" className="btn-discover">
            {this.props.cta}
          </p>
          <span ref="bLine" className="line b-line" />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/components/world/components/world-item/index.js